import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';

type DraggableWrapperProps = {
  taskId: string;
  index: number;
  disabled?: boolean;
  children: React.ReactNode;
};

const DraggableContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const DraggableWrapper = ({
  taskId,
  index,
  disabled,
  children,
}: DraggableWrapperProps) => {
  return (
    <Draggable
      key={taskId}
      draggableId={taskId}
      index={index}
      isDragDisabled={disabled}
    >
      {(provided, snapshot) => (
        <DraggableContainer
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...provided.draggableProps}
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          style={{
            ...provided.draggableProps.style,
            border: `var(--cc_size_border_width_s) solid transparent`,
            borderRadius: 'var(--cc_size_border_radius_l)',
            boxShadow: snapshot.isDragging
              ? '0 var(--cc_size_depth_2_y) var(--cc_size_depth_2_blur) var(--cc_color_depth_2)'
              : null,
            background: snapshot.isDragging
              ? 'var(--cc_color_background_1)'
              : 'none',
          }}
        >
          {children}
        </DraggableContainer>
      )}
    </Draggable>
  );
};

export default DraggableWrapper;
